import { requestInfo } from '@/lib/api';

export function requestInfoStore(requestInfo) {
  return {
    state: {
      infoRequested: false,
    },

    mutations: {
      infoRequested(state) {
        state.infoRequested = true;
      },
    },

    actions: {
      async requestInfo({ commit }, email) {
        await requestInfo(email);
        commit('infoRequested');
      },
    },
  };
}

export default requestInfoStore(requestInfo);
